module.exports = __webpack_public_path__ + "media/St 4-keyboard-hint.2ba2a0da.wav";